import * as colors from "./classTileColors";

export default {
	nutrition: colors.goldTile,
	familyhealth: colors.blueTile,
	breastfeeding: colors.salmonTile,
	infanthealth: colors.goldTile,
	childhoodeducation: colors.greenTile,
	general: colors.redTile,
	food: colors.blue2Tile,
	childhealth: colors.greenTile,
	womenshealthpregnancy: colors.purpleTile,

	// spanish
	saluddelafamilia: colors.blueTile,
	lactancia: colors.salmonTile,
	saluddelosinfantes: colors.goldTile,
	comida: colors.blue2Tile,
	saluddelosniños: colors.greenTile,
	saludyembarazodelamujer: colors.purpleTile,
};



// WEBPACK FOOTER //
// ./src/constants/categoryColors.js